import { ViewModel, View } from "binder"
import { MachinelModelEditorView } from "./machineModelEditor-view"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { MachineTypeSelectorViewModel, MachineType } from "../machineTypeSelector-viewModel";
import { IMachineModel } from "../IMachineModel";

export class MachineModelEditorViewModel extends ViewModel implements IMachineModel, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
        this.machineTypeSelector = new MachineTypeSelectorViewModel(this);
        this.machineTypeSelector.onSelectionChanged = x => this.onMachineTypeChanged(x);
    }
    GetDefaultView(): View<ViewModel> {
        return new MachinelModelEditorView();
    }
    public getTypeId(): string {
        return "VM-D1A422FF-F33E-4085-AEED-9AADD58EE176"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set machineTypeId(v: string) { this._machineTypeId = v; } public get machineTypeId(): string { return this._machineTypeId; } private _machineTypeId: string;
    public set machineTypeSelector(v: MachineTypeSelectorViewModel) { this._machineTypeSelector = v; } public get machineTypeSelector(): MachineTypeSelectorViewModel { return this._machineTypeSelector; } private _machineTypeSelector: MachineTypeSelectorViewModel;

    closePopup(result?: any) {

    }

    onMachineTypeChanged(machineType: MachineType) {
        this.machineTypeId = machineType?.id;
    }

    setMachineTypeId(id: string) {
        this.machineTypeSelector.selectById(id);
    }

    getMachineTypeId(): string {
        return this.machineTypeSelector.selectedItem?.id;
    }

    async cloneTo(machineModel: IMachineModel) {
        machineModel.id = this.id;
        machineModel.name = this.name;
        machineModel.code = this.code;
        machineModel.comment = this.comment;
        machineModel.setMachineTypeId(this.getMachineTypeId());
    }

    back() {
        this.closePopup(null);
    }

    async save(): Promise<void> {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت مدل ماشین');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت مدل ماشین تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('مدل ماشین با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت مدل ماشین', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getMachineTypeId())) {
            result.push('نوع ماشین مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.name)) {
            result.push('مدل ماشین مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.code)) {
            result.push('کد مدل ماشین مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(machineModel: IMachineModel): Promise<any>;
}

export class MachineModelInserter implements IServerUpdater {
    async execute(machineModel: IMachineModel): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/MachineModelServices/CreateMachineModel', {
                Name: machineModel.name,
                Code: machineModel.code,
                Comment: machineModel.comment ?? "",
                MachineTypeId: machineModel.getMachineTypeId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class MachineModelUpdater implements IServerUpdater {
    async execute(machineModel: IMachineModel): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/MachineModelServices/UpdateMachineModel', {
                MachineModelId: machineModel.id,
                Name: machineModel.name,
                Code: machineModel.code,
                Comment: machineModel.comment,
                MachineTypeId: machineModel.getMachineTypeId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
